export const resetCSSBody = () => {
  const styleId = "featureddealer-mfe-body-reset";

  // Check if the style tag already exists to prevent adding it multiple times.
  if (document.getElementById(styleId)) {
    return;
  }

  // Create a new <style> element.
  const style = document.createElement("style");
  style.id = styleId;

  // Add the CSS rule to remove the body margin.
  style.textContent = `body { margin: 0;}`;

  // Append the new style tag to the main document's <head>.
  document.head.appendChild(style);
};
